/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CheckTimeCalculationEligibilityRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {CheckTimeCalculationEligibilityResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const checkTimeCalculationEligibility = (request: CheckTimeCalculationEligibilityRequest, options?: CashRequestOptions) => post<CheckTimeCalculationEligibilityRequest, CheckTimeCalculationEligibilityResponse>("/proxy/services/squareup.timecards.TimeCalculationService/CheckTimeCalculationEligibility", request, {...options, rejectOnError: true })